/* eslint-disable max-len */
/* eslint-disable require-jsdoc */
// IMPORTS
import React, {useState, useEffect, Fragment} from 'react';
import {Route, Switch, BrowserRouter} from 'react-router-dom';
import Axios from 'axios';

import ScrollToTop from './utils/scrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Container from '@material-ui/core/Container';
import HomeContent from './components/HomeContent';
import ProfilePage from './pages/ProfilePage';
import GlobalStyle from './utils/globalStyles';

// PAGES
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import EthicsPage from './pages/EthicsPage';
import ArtificialIntelligencePhysicsPage from './pages/ArtificialIntelligencePhysicsPage';
import InnovationsPage from './pages/InnovationsPage';
import LegalPage from './pages/LegalPage';
import SpaceTravelPage from './pages/SpaceTravelPage';
import SpatialEngineeringPage from './pages/SpatialEngineeringPage';
import EncyclopediaPage from './pages/EncyclopediaPage';
import ClientLoginPage from './pages/ClientLoginPage';
import EmployeeLogInPage from './pages/EmployeeLogInPage';
import CoronavirusPage from './pages/CoronavirusPage';
import InvestorRelationsPage from './pages/InvestorRelationsPage';
import FAQPage from './pages/FAQPage';
import ProductsPage from './pages/ProductsPage';
import ResearchPage from './pages/ResearchPage';
import EducationPage from './pages/EducationPage';
import ArchivePage from './pages/NewsroomPage';
import SitemapPage from './pages/SitemapPage';
import EventsPage from './pages/EventsPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import ClientServicesCenterPage from './pages/ClientServicesCenterPage';
import OfficePage from './pages/OfficePage';
import BlogPage from './pages/BlogPage';
import BiodefensePage from './pages/BiodefensePage';
// import OldNewsroomPage from './pages/OldNewsroomPage';
import CEOInterviewPage from './pages/CEOInterviewPage';
import EmployeeCreateDocPage from './pages/EmployeeCreateDocPage';
import MetabolicPhysics from './pages/MetabolicPhysics';
import BiophysicsPage from './pages/BiophysicsPage';
import AstrophysicsPage from './pages/AstrophysicsPage';

/**
 * The main app component with a router switch
 * @component App
 * @return {Component} App
 */
export default function App() {
  const [articleRoutes, setArticleRoutes] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await Axios.get(
          'https://ais-backend-server.herokuapp.com/api/articles',
      ).then((res) => {
        setArticleRoutes(res.data);
      });
    }
    fetchData();
  }, []);

  return (
    <BrowserRouter>
      <GlobalStyle />

      {/* hide header when login page is displayed */}
      {location.pathname !== '/employee-login' &&
      location.pathname !== '/create-doc' ? (
        <Header />
      ) : null}

      <Container maxWidth="xl">
        <ScrollToTop />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/create-doc" component={EmployeeCreateDocPage} />
          <Route exact path="/employee-login" component={EmployeeLogInPage} />
          <Route exact path="/client-login" component={ClientLoginPage} />
          <Route exact path="/profile-page" component={ProfilePage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/careers" component={CareersPage} />
          <Route
            exact
            path="/artificial-intelligence-physics"
            component={ArtificialIntelligencePhysicsPage}
          />
          <Route exact path="/innovations" component={InnovationsPage} />
          <Route exact path="/legal" component={LegalPage} />
          <Route exact path="/space-travel" component={SpaceTravelPage} />
          <Route
            exact
            path="/SpatialEngineering"
            component={SpatialEngineeringPage}
          />
          <Route exact path="/ethics" component={EthicsPage} />
          <Route exact path="/encyclopedia" component={EncyclopediaPage} />
          <Route exact path="/coronavirus" component={CoronavirusPage} />
          <Route exact path="/investor" component={InvestorRelationsPage} />
          <Route exact path="/faq" component={FAQPage} />
          <Route exact path="/research" component={ResearchPage} />
          <Route exact path="/products" component={ProductsPage} />
          <Route exact path="/support" component={ClientServicesCenterPage} />
          <Route exact path="/education" component={EducationPage} />
          <Route exact path="/newsroom" component={ArchivePage} />
          <Route exact path="/sitemap" component={SitemapPage} />
          <Route exact path="/events" component={EventsPage} />
          <Route exact path="/privacypolicy" component={PrivacyPolicyPage} />
          <Route exact path="/termsofuse" component={TermsOfUsePage} />
          {/* <Route exact path="/newsroom" component={NewsroomPage} /> */}
          <Route exact path="/ceo" component={OfficePage} />
          <Route exact path="/blog" component={BlogPage} />
          <Route exact path="/cookiepolicy" component={CookiePolicyPage} />
          <Route exact path="/biodefense" component={BiodefensePage} />
          <Route exact path="/CEOInterview" component={CEOInterviewPage} />
          <Route exact path="/metabolic" component={MetabolicPhysics} />
          <Route exact path="/biophysics" component={BiophysicsPage} />
          <Route exact path="/astrophysics" component={AstrophysicsPage} />

          {articleRoutes.map((data, index) => {
            return (
              <Route
                key={index}
                path={data.link}
                render={() => (
                  <Fragment style={{padding: '100px'}}>
                    <HomeContent
                      category={data.category}
                      image={data.image}
                      post={data.content}
                    />
                  </Fragment>
                )}
              />
            );
          })}
        </Switch>
      </Container>
      <div style={{height: '50px'}}></div>

      {/* hide header when login page is displayed */}
      {location.pathname !== '/employee-login' &&
      location.pathname !== '/create-doc' ? (
        <Footer />
      ) : null}
    </BrowserRouter>
  );
}
